import { styled, Box, Tabs } from '@mui/material';

export const Container = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    height: '100vh',
});

export const BodyWrapper = styled(Box)({
    display: 'flex',
    flex: 1,
    height: '100%',
});

export const ContentWrapper = styled(Box)({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: '16px',
    overflowY: 'auto',
});

export const StyledTabs = styled(Tabs)({
    borderBottom: '1px solid #e0e0e0',
});

export const TabContent = styled(Box)({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    marginTop: '16px',
    height: '100%',
});
